import React, { Component } from 'react';
import { TIPO_ACOMPANHAMENTO } from '../../../../const';

class FiltroTipoAcompanhamento extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }

        //Tipo padrão
        //this.props.onChange && this.props.onChange("grafico")
    }

    render() {
        return (<div className={this.props.className}>
            <strong>{this.props.filtroRequerido && <span className="edb-padding-small-right edb-text-bold adap-text-red">*</span>}Tipo de acompanhamento:</strong>
            <br />

            <label className="edb-margin-none-bottom">
                <input type="radio" name="filtro-tipo-acompanhamento" value={TIPO_ACOMPANHAMENTO.GRAFICO}
                    onChange={() => this.props.onChange && this.props.onChange(TIPO_ACOMPANHAMENTO.GRAFICO)}
                    />
                &nbsp;
                <small>Gráficos</small>
            </label>
            <label className="edb-margin-none-bottom">
                <input type="radio" name="filtro-tipo-acompanhamento" value={TIPO_ACOMPANHAMENTO.LISTA_ALUNOS}
                    onChange={() => this.props.onChange && this.props.onChange(TIPO_ACOMPANHAMENTO.LISTA_ALUNOS)} />
                &nbsp;
                <small>Lista de alunos</small>
            </label>
            <label className="edb-margin-none-bottom">
                <input type="radio" name="filtro-tipo-acompanhamento" value={TIPO_ACOMPANHAMENTO.LISTA_ATIVIDADES}
                    onChange={() => this.props.onChange && this.props.onChange(TIPO_ACOMPANHAMENTO.LISTA_ATIVIDADES)} />
                &nbsp;
                <small>Lista de atividades</small>
            </label>

        </div>);
    }
}

export default FiltroTipoAcompanhamento;